module.exports = __webpack_public_path__ + "static/img/1.3b3320a0.png";